// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page (.auftragssuche-page) ─────────────────────────────── */

.auftragssuche-page .auftrag-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

.auftragssuche-page .auftrag-status {
  min-width: 0;
}

.auftragssuche-page .auftrag-header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.auftragssuche-page .auftrag-tabs {
  max-width: 100%;
  overflow-x: auto;
}

.auftragssuche-page .auftrag-filter-select {
  min-width: 150px;
}

.auftragssuche-page .auftrag-empty-text {
  max-width: 560px;
  margin-inline: auto;
}

/* Phone filter bar: tabs, then search + "Filter" toggle, then the folded-out selects. */
.auftragssuche-page .auftrag-filterbar {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

.auftragssuche-page .auftrag-filterbar-search {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
}

.auftragssuche-page .auftrag-filterbar-search > .input-search {
  flex: 1 1 auto;
  min-width: 0;
}

.auftragssuche-page .auftrag-filter-panel {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  padding: var(--ds-space-3);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
}

.auftragssuche-page .auftrag-filter-panel .auftrag-filter-select {
  width: 100%;
  min-width: 0;
}

/* ── Result list ────────────────────────────────────────────── */

.auftragssuche-page .auftrag-results .auftrag-item {
  display: block;
  padding: var(--ds-space-4);
}

.auftragssuche-page .auftrag-item-row {
  width: 100%;
}

.auftragssuche-page .auftrag-item-body {
  min-width: 0;
}

.auftragssuche-page .auftrag-title {
  font-size: 15px;
  display: block;
  overflow-wrap: anywhere;
}

.auftragssuche-page .auftrag-meta {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-1) var(--ds-space-4);
  margin: var(--ds-space-1) 0;
  color: var(--ds-text-2);
  font-size: 13px;
  overflow-wrap: anywhere;
}

.auftragssuche-page .auftrag-desc {
  margin-bottom: var(--ds-space-2);
  font-size: 13px;
}

.auftragssuche-page .auftrag-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--ds-space-2);
}

.auftragssuche-page .auftrag-quick-actions {
  display: flex;
  gap: var(--ds-space-1);
}

@media (max-width: 767.98px) {
  .auftragssuche-page .auftrag-header-actions {
    width: 100%;
  }

  .auftragssuche-page .auftrag-header-actions > .ant-btn {
    flex: 1 1 0;
  }

  .auftragssuche-page .auftrag-results .auftrag-item {
    padding: var(--ds-space-3);
  }

  /* Actions sit under the text: the primary button takes the row, icon buttons follow. */
  .auftragssuche-page .auftrag-actions {
    flex-direction: row;
    align-items: center;
  }

  .auftragssuche-page .auftrag-offer-btn {
    flex: 1 1 auto;
  }

  .auftragssuche-page .auftrag-quick-actions {
    margin-inline-start: auto;
  }

  .auftragssuche-page .auftrag-quick-actions .ant-btn {
    min-width: var(--ds-touch);
    height: var(--ds-touch);
  }
}

/* ── Prepare offer modal (.auftrag-offer-modal, rendered in a portal) ── */

.auftrag-offer-modal .auftrag-totals {
  width: 100%;
}

.auftrag-offer-modal .auftrag-totals td {
  padding: 2px 0;
  vertical-align: top;
}

.auftrag-offer-modal .auftrag-totals td:last-child {
  text-align: end;
  white-space: nowrap;
  padding-inline-start: var(--ds-space-4);
}

.auftrag-offer-modal .auftrag-totals-grand td {
  font-weight: 600;
  border-top: 1px solid var(--ds-border-soft);
}

.auftrag-offer-modal .auftrag-driver {
  margin-bottom: 10px;
}

/* ── Lead detail drawer (.auftrag-lead-drawer, rendered in a portal) ── */

.auftrag-lead-drawer .auftrag-lead-head {
  display: flex;
  align-items: flex-start;
  gap: var(--ds-space-4);
}

.auftrag-lead-drawer .auftrag-lead-head-text {
  flex: 1 1 auto;
  min-width: 0;
}

.auftrag-lead-drawer .auftrag-lead-text {
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/Auftragssuche/auftragssuche.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kEAAkE;;AAElE;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,uFAAuF;EACvF;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA,2EAA2E;;AAE3E;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* ── Page (.auftragssuche-page) ─────────────────────────────── */\n\n.auftragssuche-page .auftrag-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n.auftragssuche-page .auftrag-status {\n  min-width: 0;\n}\n\n.auftragssuche-page .auftrag-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.auftragssuche-page .auftrag-tabs {\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.auftragssuche-page .auftrag-filter-select {\n  min-width: 150px;\n}\n\n.auftragssuche-page .auftrag-empty-text {\n  max-width: 560px;\n  margin-inline: auto;\n}\n\n/* Phone filter bar: tabs, then search + \"Filter\" toggle, then the folded-out selects. */\n.auftragssuche-page .auftrag-filterbar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n.auftragssuche-page .auftrag-filterbar-search {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.auftragssuche-page .auftrag-filterbar-search > .input-search {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.auftragssuche-page .auftrag-filter-panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  padding: var(--ds-space-3);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n}\n\n.auftragssuche-page .auftrag-filter-panel .auftrag-filter-select {\n  width: 100%;\n  min-width: 0;\n}\n\n/* ── Result list ────────────────────────────────────────────── */\n\n.auftragssuche-page .auftrag-results .auftrag-item {\n  display: block;\n  padding: var(--ds-space-4);\n}\n\n.auftragssuche-page .auftrag-item-row {\n  width: 100%;\n}\n\n.auftragssuche-page .auftrag-item-body {\n  min-width: 0;\n}\n\n.auftragssuche-page .auftrag-title {\n  font-size: 15px;\n  display: block;\n  overflow-wrap: anywhere;\n}\n\n.auftragssuche-page .auftrag-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-1) var(--ds-space-4);\n  margin: var(--ds-space-1) 0;\n  color: var(--ds-text-2);\n  font-size: 13px;\n  overflow-wrap: anywhere;\n}\n\n.auftragssuche-page .auftrag-desc {\n  margin-bottom: var(--ds-space-2);\n  font-size: 13px;\n}\n\n.auftragssuche-page .auftrag-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: var(--ds-space-2);\n}\n\n.auftragssuche-page .auftrag-quick-actions {\n  display: flex;\n  gap: var(--ds-space-1);\n}\n\n@media (max-width: 767.98px) {\n  .auftragssuche-page .auftrag-header-actions {\n    width: 100%;\n  }\n\n  .auftragssuche-page .auftrag-header-actions > .ant-btn {\n    flex: 1 1 0;\n  }\n\n  .auftragssuche-page .auftrag-results .auftrag-item {\n    padding: var(--ds-space-3);\n  }\n\n  /* Actions sit under the text: the primary button takes the row, icon buttons follow. */\n  .auftragssuche-page .auftrag-actions {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .auftragssuche-page .auftrag-offer-btn {\n    flex: 1 1 auto;\n  }\n\n  .auftragssuche-page .auftrag-quick-actions {\n    margin-inline-start: auto;\n  }\n\n  .auftragssuche-page .auftrag-quick-actions .ant-btn {\n    min-width: var(--ds-touch);\n    height: var(--ds-touch);\n  }\n}\n\n/* ── Prepare offer modal (.auftrag-offer-modal, rendered in a portal) ── */\n\n.auftrag-offer-modal .auftrag-totals {\n  width: 100%;\n}\n\n.auftrag-offer-modal .auftrag-totals td {\n  padding: 2px 0;\n  vertical-align: top;\n}\n\n.auftrag-offer-modal .auftrag-totals td:last-child {\n  text-align: end;\n  white-space: nowrap;\n  padding-inline-start: var(--ds-space-4);\n}\n\n.auftrag-offer-modal .auftrag-totals-grand td {\n  font-weight: 600;\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.auftrag-offer-modal .auftrag-driver {\n  margin-bottom: 10px;\n}\n\n/* ── Lead detail drawer (.auftrag-lead-drawer, rendered in a portal) ── */\n\n.auftrag-lead-drawer .auftrag-lead-head {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--ds-space-4);\n}\n\n.auftrag-lead-drawer .auftrag-lead-head-text {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.auftrag-lead-drawer .auftrag-lead-text {\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
